var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-select',_vm._b({attrs:{"append-to-body":"","calculate-position":_vm.withPopper,"value":_vm.selectedValue},on:{"input":_vm.handleInput}},'v-select',_vm.$attrs,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }